import { troubleshootingDashboard } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchDataJson } from "../FetchApi";


class TroubleshootingDashboardService extends CrudService {
  constructor() {
    super(troubleshootingDashboard);
  }

  async getElevatorsWithIssues(date) {
    return fetchDataJson(`${troubleshootingDashboard}/GetElevatorsWithIssues?date=${date}`, {
      method: "GET",
    });
  }
}

export default new TroubleshootingDashboardService();
